import Utils from "./Utils";


export const generarSelectorAlmacenes = (originalData) => {

    const TODOS = "Todos";

    if (!Array.isArray(originalData)) {
        console.warn("createSelectorOptions received non-array data:", originalData);
        return [{ value: "0", label: TODOS}];
    }

    return [
        { value: "0", label: TODOS },
        ...originalData.map(item => ({
            value: item.CODIGO,
            label: Utils.toCapitalize(item.NOMBRE)
        }))
    ];
};